module.exports = __webpack_public_path__ + "static/2-db5e8cc981ab8a27d416c7e3d59bfcef.jpg";